import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsDevice } from '../DeviceSettings';
import EnableOrDisableDeviceMutationContainer from 'settings/containers/EnableOrDisableDeviceMutationContainer';
// @ts-ignore
import ResendConfirmationEmail from 'settings/components/ResendConfirmationEmail';
import RemoveDeviceFromUserConfirmDialog from 'settings/components/RemoveDeviceFromUserConfirmDialog';
import LinkDeviceVerificationCodeBoxDialog from 'user/components/LinkDeviceVerificationCodeBoxDialog';

export type Props = {
  emailDevice: DeviceSettingsDevice;
  deviceIsOnlyLoginDevice: boolean;
  isRosteredEnforcement: boolean;
  refetch: () => void;
};

export type State = {
  confirmRemoveDialogIsOpen: boolean;
  linkDeviceVerificationCodeBoxDialogIsOpen: boolean;
};

export default class DeviceSettingsEmailItem extends React.Component<Props, State> {
  state = {
    confirmRemoveDialogIsOpen: false,
    linkDeviceVerificationCodeBoxDialogIsOpen: false,
  };

  showConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: true });
  };

  hideConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: false });
  };

  showEmailConfirmationDialog = () => {
    this.setState({ linkDeviceVerificationCodeBoxDialogIsOpen: true });
  };

  hideEmailConfirmationDialog = () => {
    this.setState({ linkDeviceVerificationCodeBoxDialogIsOpen: false });
  };

  renderSecondaryText = () => {
    const { emailDevice } = this.props;
    if (emailDevice.confirmed) {
      return 'Email';
    } else if (emailDevice.deliverable) {
      return (
        <span data-test="unverified-secondary-text">
          Pending confirmation.{' '}
          <ResendConfirmationEmail
            email={emailDevice}
            onShowDialog={this.showEmailConfirmationDialog}>
            Resend email
          </ResendConfirmationEmail>
        </span>
      );
    } else {
      return (
        <span data-test="undeliverable-secondary-text">
          Please{' '}
          <ResendConfirmationEmail email={emailDevice}>confirm this email</ResendConfirmationEmail>{' '}
          to receive notifications.
        </span>
      );
    }
  };

  render() {
    const { emailDevice, deviceIsOnlyLoginDevice, isRosteredEnforcement } = this.props;
    return (
      <React.Fragment>
        <Modal data-test="remove-email-device-modal" isOpen={this.state.confirmRemoveDialogIsOpen}>
          <RemoveDeviceFromUserConfirmDialog
            deviceName={emailDevice.label || 'Your device'}
            deviceId={emailDevice.id}
            onRequestHide={this.hideConfirmRemoveDialog}
          />
        </Modal>
        <Modal
          data-test="resend-email-modal"
          isOpen={this.state.linkDeviceVerificationCodeBoxDialogIsOpen}>
          <LinkDeviceVerificationCodeBoxDialog
            deviceName={emailDevice.label || 'Your device'}
            onDone={this.props.refetch}
            onRequestHide={this.hideEmailConfirmationDialog}
          />
        </Modal>
        <EnableOrDisableDeviceMutationContainer>
          {enableOrDisableDevice => (
            <DeviceSettingsItemTemplate
              deviceType="email"
              deviceExists
              deviceIsRostered={emailDevice.rostered && isRosteredEnforcement}
              deviceIsEnabled={emailDevice.enabled}
              deviceCanBeEnabledOrDisabled
              primaryTextLabel={emailDevice.label}
              secondaryTextLabel={this.renderSecondaryText()}
              onRemoveDevice={this.showConfirmRemoveDialog}
              onEnableOrDisableDevice={() =>
                enableOrDisableDevice({
                  variables: { deviceId: emailDevice.id, enabled: !emailDevice.enabled },
                })
              }
              deviceIsOnlyLoginDevice={deviceIsOnlyLoginDevice}
            />
          )}
        </EnableOrDisableDeviceMutationContainer>
      </React.Fragment>
    );
  }
}
